import * as React from "react"
import { Fragment, useContext } from "react"
import styled from "styled-components"
import GImage from "../../../gatsby/GImage"
import { BasketContext } from "../../context/BasketProvider"
import LinkButton from "../../components/button/LinkButton"
import GLink from "../../../gatsby/GLink"
import FlipImage from "../../components/image/FlipImage"
import { BasketItemType } from "model"
import { formatPrice, parsePrice } from "model"

const Container = styled.div`
  display: flex;
  width: 100%;
`
const ImageContainer = styled.div`
  margin-right: 10px;
  max-width: 100px;
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`
const Name = styled.div`
  font-weight: bold;
  font-size: 0.8em;
`
const Price = styled.div`
  font-size: 0.9em;
`
const Attributes = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const Thumbnail = styled.div`
  width: 30px;
`

const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  width: 100%;
`
const Remove = styled.div`
  font-size: 0.9em;
`

interface Props {
  box?: BasketItemType
  card?: BasketItemType
  items?: BasketItemType[]
  adjustable: boolean
}

const ByoBasketItem = ({ box, card, items = [], adjustable }: Props) => {
  const basket = useContext(BasketContext)

  const productsTotal = items.reduce((total, item) => {
    return total + parsePrice(item.product.price) * item.quantity
  }, 0)

  const boxTotal = box ? parsePrice(box.product.price) : 0
  const cardTotal = card ? parsePrice(card.product.price) : 0
  const total = productsTotal + boxTotal + cardTotal

  const handleRemove = async () => {
    for (let i = 0; i < items.length; i++) {
      await basket.removeProduct(items[i].key, items[i].product, false)
    }

    if (box) {
      await basket.removeProduct(box.key, box.product, false)
    }

    if (card) {
      await basket.removeProduct(card.key, card.product, false)
    }

    await basket.fetchBasket()
  }

  const renderThumbnails = (item: BasketItemType) => {
    const thumbnails = []
    for (let i = 0; i < item.quantity; i++) {
      thumbnails.push(
        <Thumbnail>
          <FlipImage image={item.product.image || item.product.imageSmall} />
        </Thumbnail>
      )
    }

    return <Fragment>{thumbnails}</Fragment>
  }

  return (
    <Container>
      <GLink to={`/build-your-own-gift-box`} onClick={() => basket.toggle(false)}>
        <ImageContainer>{box && <GImage image={box.product.image} />}</ImageContainer>
      </GLink>
      <Content>
        <Name>
          <GLink to={`/build-your-own-gift-box`} onClick={() => basket.toggle(false)}>
            Build Your Own Gift Box
          </GLink>
        </Name>
        <Price>{formatPrice(total)}</Price>
        <Attributes>{items.map(renderThumbnails)}</Attributes>

        {adjustable && (
          <Toolbar>
            <Remove>
              <LinkButton onClick={handleRemove}>Remove</LinkButton>
            </Remove>
          </Toolbar>
        )}
      </Content>
    </Container>
  )
}

export default ByoBasketItem
